/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupplierDto as DigiworkMaitreDPosDtoSuppliersSupplierDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';
import { UpdateSupplierDto as DigiworkMaitreDPosDtoSuppliersUpdateSupplierDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Suppliers/update-supplier-dto';

export interface UpdateSupplier$Params {
  supplierId: string;
      body?: DigiworkMaitreDPosDtoSuppliersUpdateSupplierDto
}

export function updateSupplier(http: HttpClient, rootUrl: string, params: UpdateSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>> {
  const rb = new RequestBuilder(rootUrl, updateSupplier.PATH, 'put');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>;
    })
  );
}

updateSupplier.PATH = '/api/suppliers/{supplierId}';
